import { Button, Flex, Icon, Text, Heading, Link } from '@chakra-ui/react';
import NextLink from 'next/link';
import { FC } from 'react';

import ArrowIcon from '@/assets/icons/ic-arrow-tilted.svg';

export const SubmitTodayFullWidth: FC = () => {
  return (
    <Flex
      justifyContent="space-between"
      alignItems={{ base: 'flex-start', md: 'center' }}
      flexDirection={{ base: 'column', md: 'row' }}
      gap={4}
      my={20}
    >
      <Flex mb={{ base: 4, sm: 0 }} flexDirection="column">
        <Heading size="xl" as="h3">
          Submit Today
        </Heading>
        <Text fontSize="lg" my={4}>
          Join thousands of researchers already using Underline to grow their academic impact.
        </Text>
        <Text fontSize="lg">
          For questions, contact{' '}
          <Link variant="highlight" href="mailto:support@underline.io">
            support@underline.io
          </Link>
        </Text>
      </Flex>
      <NextLink href="/submit">
        <Button rightIcon={<Icon as={ArrowIcon} color="white" h={5} w={5} />} size="lg">
          Submit Your Presentation Now
        </Button>
      </NextLink>
    </Flex>
  );
};
